<template>
  <div class="tags">
    <div
      @click="toggle(getValue(item))"
      :class="{ active: value.includes(getValue(item)) }"
      class="tag-wrapper"
      v-for="item in list"
      :key="item.id"
    >
      <div class="tag">
        <v-icon size="24">{{ "$team_" + getValue(item) }}</v-icon>
        {{ getText(item) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: {
    value: Array,
    list: Array,
    itemText: [String, Function],
    itemValue: [String, Function],
  },
  methods: {
    getText(item) {
      if (typeof this.itemText == "function") {
        return this.itemText(item);
      } else {
        return item[this.itemText];
      }
    },
    getValue(item) {
      if (typeof this.itemValue == "function") {
        return this.itemValue(item);
      } else {
        return item[this.itemValue];
      }
    },
    toggle(itemValue) {
      if (this.value.includes(itemValue)) {
        this.$emit(
          "input",
          this.value.filter((id) => id != itemValue)
        );
      } else {
        this.$emit("input", [...this.value, itemValue]);
      }

      this.$emit("changed");
    },
  },
};
</script>

<style scoped lang="scss">
.tags {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  align-items: center;
  justify-content: center;
  max-width: 800px;
}

.tag {
  background: #ffffff;
  border: 2px solid $primary;
  color: $jude-lightred;
  border-radius: 22px;
  margin: 11px;
  font-family: $body-font-family;
  font-weight: 800;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.05em;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 31px 3px 10px;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;

  .v-icon {
    color: $jude-yellow;
    margin-right: 0.5em;
  }
}

.tag-wrapper {
  &.active .tag {
    background: $jude-darkred;
    color: white;
  }

  &:first-child {
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 960px) {
  .tags {
    margin: 0 20px;
  }
}
</style>
